import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useParams } from "react-router-dom";
import { getPublicShareByToken, getSharePresets, } from "@/shared/api";
import { Loader } from "@/shared/ui";
import { Seo } from "@/shared/components/Seo";
import { ShareStage } from "@/features/share";
import { emptyPresets } from "@/features/share/lib/resolveConfig";
import { extractFontKeyFromConfig, preloadShareFont, } from "@/features/share/lib/shareFonts";
import styles from "./SharePage.module.scss";
/**
 * Публичная страница-подарок по токену (без auth). Вся сцена (коробка →
 * открытие → анимация → оформление + плеер) инкапсулирована в ShareStage.
 */
export const SharePage = () => {
    const { token } = useParams();
    const [data, setData] = React.useState(null);
    const [presets, setPresets] = React.useState(emptyPresets);
    const [status, setStatus] = React.useState("loading");
    React.useEffect(() => {
        if (!token) {
            setStatus("error");
            return;
        }
        let cancelled = false;
        setStatus("loading");
        Promise.all([
            getPublicShareByToken(token),
            getSharePresets("web").catch(() => emptyPresets()),
        ])
            .then(async ([share, presetData]) => {
            // Ждём шрифт до показа сцены — иначе пользователь видит FOUT (моргание).
            await preloadShareFont(extractFontKeyFromConfig(share.config));
            if (cancelled)
                return;
            setData(share);
            setPresets(presetData);
            setStatus("ok");
        })
            .catch(() => {
            if (!cancelled)
                setStatus("error");
        });
        return () => {
            cancelled = true;
        };
    }, [token]);
    if (status === "loading") {
        return (_jsx("div", { className: styles.centered, children: _jsx(Loader, { size: "lg" }) }));
    }
    if (status === "error" || !data) {
        return (_jsxs("div", { className: styles.centered, children: [_jsx(Seo, { title: "\u041F\u043E\u0434\u0430\u0440\u043E\u043A \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u2014 \u0412\u0438\u0440\u0442\u0443\u043E\u0437", noindex: true }), _jsxs("div", { className: styles.notFound, children: [_jsx("h1", { children: "\u041F\u043E\u0434\u0430\u0440\u043E\u043A \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D" }), _jsx("p", { children: "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430." })] })] }));
    }
    const recipient = data.config.recipient;
    const shareTitle = recipient
        ? `Песня в подарок для ${recipient} — Виртуоз`
        : `${data.audio.title || "Песня-подарок"} — Виртуоз`;
    return (_jsxs("div", { className: styles.stageWrap, children: [_jsx(Seo, { title: shareTitle, description: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u0435\u0441\u043D\u044F-\u043F\u043E\u0434\u0430\u0440\u043E\u043A. \u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0441\u043B\u0443\u0448\u0430\u0442\u044C \u0442\u0440\u0435\u043A \u0438 \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435.", image: data.audio.cover_url || undefined, type: "music.song" }), _jsx(ShareStage, { type: data.type, config: data.config, presets: presets, audio: data.audio, token: data.token, className: styles.stageFill })] }));
};
export default SharePage;
